import React, { Component } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { AnalyticsLocationProvider } from 'latitude-analytics';
import { Link } from '@latitude/link';
import { RatesBox } from '@latitude/rates-box';
import { List, ListItem } from '@latitude/list';
import Section from '../Section/Section';
import LoanDetails from './LoanDetails';
import Modal from '../Modal/Modal';
import Productdata from '../../data/json/Products/products.json';
import ratesData from '../../data/json/Rates/rates.json';
import './_loan-rates.scss';
import { Heading2 } from '../Heading/Heading';
import { COLOR, BREAKPOINT } from '../../utils/constants';

class LoanRates extends Component {
  state = {
    isModalOpen: false,
    isFixedVsVariableModalOpen: false
  };

  handleModalRequestClose = () => {
    this.setState({ isModalOpen: false });
  };
  handleFixedVsVariableModalRequestClose = () => {
    this.setState({ isFixedVsVariableModalOpen: false });
  };

  handleLinkClick = event => {
    event.stopPropagation();
    this.setState({
      isModalOpen: true
    });
  };
  handleFixedVsVariableLinkClick = event => {
    event.stopPropagation();
    this.setState({
      isFixedVsVariableModalOpen: true
    });
  };

  render() {
    const rateBoxType =
      this.props.rateBoxType &&
      this.props.rateBoxType.length > 0 &&
      this.props.rateBoxType.split(',');

    const rateBoxType2 =
      this.props.rateBoxType2 &&
      this.props.rateBoxType2.length > 0 &&
      this.props.rateBoxType2.split(',');

    const rateList = this.props.rates ||  ratesData; 

    return (
      <Section id="rates" className="rates-loan-details__section">
        <div className="row">
          <div
            className={`col-12 text-center ${this.props.padBottom || null} ${
              this.props.isBranded ? 'col-lg-4' : 'col-md-5'
            } `}
            css="margin-bottom:30px;"
          >
            <Heading2>Interest Rates</Heading2>
            <div css="max-width:350px; margin-right:auto;">
              {rateBoxType &&
                rateBoxType.map((rateType, index) => (
                  <RatesBox
                    isBranded={this.props.isBranded}
                    key={index}
                    type={rateType}
                    fullWidth
                    data={rateList}
                  />
                ))}
              {rateBoxType2 &&
                rateBoxType2.map((rateType2, index) => (
                  <RatesBox
                    isBranded={this.props.isBranded}
                    darkBlue
                    theme="secondary"
                    key={index}
                    type={rateType2}
                    fullWidth
                    data={rateList}
                  />
                ))}
            </div>
            <AnalyticsLocationProvider location="Rates">
              {this.props.hideInfoModal ? null : (
                <div className="loan-type">
                  <svg
                    height="16px"
                    width="16px"
                    className="exclamation"
                    role="img"
                  >
                    <use
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      xlinkHref="/assets/icons/icons-sprite.svg#info-block"
                    />
                  </svg>
                  <Link
                    id="secured-vs-unsecured"
                    onClick={this.handleLinkClick}
                    href="#"
                    role="presentation"
                    className="loan-type-link"
                    data-trackid="rates-secured-vs-unsecured-link"
                  >
                    Secured vs Unsecured loan?
                  </Link>
                  <br />
                  <svg
                    height="16px"
                    width="16px"
                    className="exclamation"
                    role="img"
                  >
                    <use
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      xlinkHref="/assets/icons/icons-sprite.svg#info-block"
                    />
                  </svg>
                  <Link
                    onClick={this.handleFixedVsVariableLinkClick}
                    href="#"
                    role="presentation"
                    className="loan-type-link"
                    data-trackid="rates-fixed-vs-variable-link"
                  >
                    Fixed vs Variable loan?
                  </Link>

                  {this.props.determineRateLink && (
                    <div className="loan-type">
                      <svg
                        height="16px"
                        width="16px"
                        className="exclamation"
                        role="img"
                      >
                        <use
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          xlinkHref="/assets/icons/icons-sprite.svg#info-block"
                        />
                      </svg>
                      <Link
                        className="loan-type-link"
                        data-trackid="lets-talk-loan-details-determine-rate"
                        href="/how-interest-rates-are-determined/"
                      >
                        How is my interest rate determined?
                      </Link>
                    </div>
                  )}
                </div>
              )}
            </AnalyticsLocationProvider>
          </div>
          <div className={`${this.props.isBranded ? 'col-lg-8' : 'col-md-7'}`}>
            <LoanDetails isBranded={this.props.isBranded} {...this.props}/>
          </div>
          <Modal
            id="secured-vs-unsecured"
            isOpen={this.state.isModalOpen}
            onRequestClose={this.handleModalRequestClose}
            title={Productdata.securedUnsecuredText.title}
            content={Productdata.securedUnsecuredText.content}
            ariaHideApp={this.state.isModalOpen}
          />
          <Modal
            isOpen={this.state.isFixedVsVariableModalOpen}
            onRequestClose={this.handleFixedVsVariableModalRequestClose}
            title="Fixed vs Variable loan?"
            content={
              <>
                When applying for a personal loan, one decision you need is to
                make is whether you want a fixed or variable loan.
                <br />
                <br />
                <strong>Fixed loan:</strong>
                <List>
                  <ListItem>
                    Your rate remains fixed for the life of your
                    loan
                  </ListItem>
                  <ListItem>
                    An early termination fee of $500 applies if you payout your
                    loan in full up until the last 3 months of the loan. No
                    early termination fee applies in the final 3 months of the
                    loan
                  </ListItem>
                </List>
                <br />
                <strong>Variable loan:</strong>
                <List>
                  <ListItem>
                    Your rate could change, up or down, during
                    your loan term
                  </ListItem>
                  <ListItem>No early termination fee</ListItem>
                </List>
              </>
            }
            ariaHideApp={this.state.isFixedVsVariableModalOpen}
          />
        </div>
        <AnalyticsLocationProvider location="Fees & charges">
          <div className="loan-rates__button-container">
            {this.props.button2 && (
              <LinkButton
                {...this.props.button2}
                className={classnames(
                  'loan-rates__button button--primary',
                  this.props.button2.className
                )}
              >
                {this.props.button2.text}
              </LinkButton>
            )}
            {this.props.button1 && (
              <LinkButton
                {...this.props.button1}
                className={classnames(
                  'loan-rates__button',
                  this.props.button1.className
                )}
                tertiary
              >
                {this.props.button1.text}
              </LinkButton>
            )}
          </div>
        </AnalyticsLocationProvider>
      </Section>
    );
  }
}

const LinkButton = styled(Link)`
  @media (min-width: ${BREAKPOINT.MD}) {
    min-width: 160px;
  }
`;

const LoanRatesContainer = styled.div`
  section.rates-loan-details__section {
    background-color: transparent;
  }

  .section.rates-loan-details__section h2 {
    font-size: 24px;
    text-align: left;
    margin: 0 0 24px;
    color: ${COLOR.BLACK};

    @media (min-width: ${BREAKPOINT.LG}) {
      font-size: 32px;
    }
  }

  .loan-type {
    text-align: left;
    > a.loan-type-link {
      font-size: 14px;
      color: ${COLOR.BLACK} !important;
      border-bottom: 0 !important;
      text-decoration: underline !important;
    }
  }

  .fees-charges__table {
    background-color: ${COLOR.WHITE};
    border: solid 1px ${COLOR.GREY10};
    font-weight: 300;
    overflow: hidden;
    color: ${COLOR.GREY75};

    hr.table__rule {
      width: 102%;
      height: 1px;
      background-color: ${COLOR.GREY10};
      margin: 0 0 12px -1%;
      border: 0;
    }

    .table__cell {
      padding: 0 24px 12px 24px;

      &.font-weight-bold {
        font-weight: normal !important;
      }
    }

    .table__row {
      &:first-child,
      &:last-child {
        hr {
          margin: 0 0 24px;
          background-color: transparent;
        }
      }
      &:last-child {
        hr {
          margin: 0 0 12px;
        }
      }
    }
    .table__row--border-bottom {
      .table__cell {
        padding-bottom: 12px;
      }
    }
    .table__row--border-bottom {
      border: 0;
    }
  }

  p.small-text {
    padding: 12px 0;
    border-top: 0;

    &:empty {
      display: none;
    }
  }
`;

export default props =>
  !props.isBranded ? (
    <LoanRates {...props} />
  ) : (
    <LoanRatesContainer>
      <LoanRates {...props} />
    </LoanRatesContainer>
  );
